<template>
    <div class="order-box-left">
        <div class="top-search item">
            <div class="label">订单筛选</div>
            <div style="width:100%; margin-top:8px">
                <vs-button @click="emptySearch" type="border" size="small" class="search-btn">清空</vs-button>
                <vs-button @click="handleSearch" type="border" size="small" class="search-btn query-btn">查询</vs-button>
            </div>
        </div>

        <div class="order-number item">
            <div class="label">客户编码</div>
            <el-input placeholder="客户编码" v-model="selectTJ.outCode"></el-input>
        </div>
        <div class="order-number item">
            <div class="label">客户名称</div>
            <el-input placeholder="客户名称" v-model="selectTJ.name"></el-input>
        </div>
        <div class="order-number item">
            <div class="label">客户类型</div>
            <v-select v-model="selectTJ.type" :options="typeOptions" :reduce="opt => opt.label" placeholder="请选择"
                class="select-wrap">
                <div slot="no-options">暂无选项</div>
            </v-select>
        </div>
        <div class="order-number item m-t-30">
            <div class="label">客户类别</div>
            <v-select v-model="selectTJ.category" :options="categoryOptions" :reduce="opt => opt.label" placeholder="请选择"
                class="select-wrap">
                <div slot="no-options">暂无选项</div>
            </v-select>
        </div>
        <!-- <div class="order-number item">
            <div class="label">所属区域</div>
            <v-select v-model="searchData.buyerType" :options="bodyTypeOptions" :reduce="buyer => buyer"
                placeholder="请选择" class="select-wrap">
                <div slot="no-options">暂无选项</div>
            </v-select>
        </div>
        <div class="order-number item">
            <div class="label">城市级别</div>
            <v-select v-model="searchData.value1" :options="bodyTypeOptions" :reduce="buyer => buyer" placeholder="请选择"
                class="select-wrap">
                <div slot="no-options">暂无选项</div>
            </v-select>
        </div> -->
        <div class="order-number item">
            <div class="label">价格模板</div>
            <v-select v-model="selectTJ.priceDetailEntry" :options="priceOptions" :reduce="opt => opt.id" placeholder="请选择"
                class="select-wrap">
                <div slot="no-options">暂无选项</div>
            </v-select>

        </div>
        <!-- <div class="order-number item">
            <div class="label">订单编号</div>
            <vs-input v-model="searchData.orderNo" style="margin-top:5px" class="form-item" placeholder="请输入订单编号" v-validate="'required'" />
        </div> -->
        <!-- <div class="timer item">
            <div class="label">订单时间</div>
            
        </div> -->
        <!-- <vs-collapse ref="collapse" class="collapse item">
            <vs-collapse-item>
                <div style="font-size: 14px;" slot="header"><span class="label">订单状态</span></div>
                <ul class="centerx">
                    <li style="height:30px" v-for="(item, index) in orderStatusList" :key="index">
                        <vs-checkbox v-model="searchData.orderStatus" :vs-value="item.value">{{ item.label }}</vs-checkbox>
                    </li>
                </ul>
            </vs-collapse-item>

            <vs-collapse-item>
                <div style="font-size: 14px" slot="header"><span class="label">订单渠道</span></div>
                <ul class="centerx">
                    <li style="height:30px" v-for="(item, index) in orderWayList" :key="index">
                        <vs-checkbox v-model="searchData.orderWay" :vs-value="item.value">{{ item.label }}</vs-checkbox>
                    </li>
                </ul>
            </vs-collapse-item>
        </vs-collapse> -->
    </div>
</template>

<script>
    import {Mod_Clients} from "../../server-api/Clients";
    export default {
        props: {

        },
        components: {

        },
        // props: {
        //   dealerTypeList: Array,
        //   required: true
        // },

        data() {
            return {
                searchData: {
                    value1: '',  //城市级别
                    bodyId: '', //主体id
                    buyer: '', //买家名称id
                    buyerName: '',//买家名称
                    buyerType: '', //买家类型
                    orderNo: '', // 查询的订单编号
                    fromDate: '',
                    toDate: '',
                    orderStatus: [],
                    orderWay: [],
                    dealerTypeList: [],
                    isTab: false,
                },
                selectTJ: {
                    name: null,  //客户名称
                    outCode: null,  //客户编码
                    type: null,  //类型
                    category: null, //类别
                    priceDetailEntry:null, //价格模板

                },
                buyerOptions: [], //模糊搜索买家名称
                orderSearchInfo: [], //查询缓存
                searchTime: '',
                typeOptions:[],  //类型条件数据
                categoryOptions:[],
                priceOptions:[],

                // buyerTypeOptions: [
                //     {id: '1', label: '总部'},
                //     {id: '2', label: '省代'},
                //     {id: '3', label: '地代'},
                //     {id: '4', label: '零售商'}
                // ],
                bodyTypeOptions: [],
                buyerTypeOptions: this.buyerTypes,
            };
        },
        created() {
            this.getQueryData()

        },
        async mounted() {

        },
        methods: {
            async getQueryData(){
                let res1= await Mod_Clients.conditionQuery()
                console.log(res1,"查询条件")
                this.typeOptions=res1.type.map((v)=>{
                    return{
                        label:v.customerName,
                        id:v.customerCode
                    }
                })
                 this.priceOptions=res1.price.map((v)=>{
                    return{
                        label:v.priceName,
                        id:v.id
                    }
                })
                this.categoryOptions=res1.category.map((v,i)=>{return {label:v,id:i}})
                console.log(this.priceOptions,"价格模板==========")
            },
            handleSearch() {
                this.$emit('search', this.selectTJ)

            },
            emptySearch() {
                this.selectTJ={}
                this.$emit('emptySearch')
            }

        }
    };
</script>

<style lang="scss" scoped>
    @import './order.scss';
    .m-t-30{
        margin-top: 30px;
    }
    .order-box-left {
        background: rgb(255, 255, 255);
        width: 100%;
        height: 100%;

        .top-search {
            @include flex-mixin(row, center, space-between);
            display: block !important;
            height: 80px;
            border-bottom: 1px solid rgb(235, 234, 234);
        }

        /deep/ .v-select {
            width: 100%;
        }

        .order-number {
            height: 87px;
        }

        .timer {
            width: 100%;

            .flatpickr-input {
                width: 100%;
            }
        }

        .collapse {
            /deep/ .vs-collapse-item {
                border: none !important;

                .vs-collapse-item--header {
                    padding: 12px 0 !important;
                }

                .con-content--item {
                    padding: 0;
                }
            }
        }

        .item {
            padding: 12px;
        }

        .label {
            font-size: 14px;
            font-weight: 500;
            color: #14151b;
        }

        .form-item {
            width: 100%;
            height: 38px;
        }
    }

    .search-btn {
        padding: 5px 8px !important;
        width: 46%;
        margin: 0 2%;
    }
</style>